import React from "react";
import MultiSelectDropdown from "../../../globalComponents/form/dropdowns/MultiSelectDropdown";

// Global brand colour token – matches #3f88a5 used across Settings
const ACCENT = "#3f88a5";

const FilterSectionForComparativeAnalysis = ({
  financialYearOptions = [],
  selectedFinancialYears = [],
  setSelectedFinancialYears,

  moduleOptions = [],
  selectedModules = [],
  setSelectedModules,

  primaryLocationOptions = [],
  selectedPrimaryLocation = "",
  setSelectedPrimaryLocation,

  compareLocationOptions = [],
  selectedCompareLocation = "",
  setSelectedCompareLocation,

  onClearFilters,
}) => {
  return (
    <div
      style={{
        background: "#fff",
        borderRadius: 10,
        padding: "14px 18px",
        marginBottom: 20,
        boxShadow: "0 2px 10px rgba(0,0,0,0.06)",
        border: "1px solid #e2e8f0",
      }}
    >
      {/* Header row */}
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          marginBottom: 14,
        }}
      >
        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
          {/* Left accent bar – matches settings tab indicator */}
          <div
            style={{
              width: 3,
              height: 20,
              borderRadius: 2,
              background: ACCENT,
              flexShrink: 0,
            }}
          />
          <span
            style={{
              fontSize: 14,
              fontWeight: 700,
              color: "#1e293b",
              letterSpacing: "0.01em",
            }}
          >
            Comparative Analysis Filters
          </span>
        </div>

        {/* Clear button – settings style */}
        <button
          type="button"
          onClick={onClearFilters}
          style={{
            padding: "5px 14px",
            borderRadius: 7,
            border: `1.5px solid ${ACCENT}`,
            background: "transparent",
            cursor: "pointer",
            fontSize: 12,
            fontWeight: 600,
            color: ACCENT,
            display: "flex",
            alignItems: "center",
            gap: 6,
            transition: "all 0.15s",
          }}
          onMouseEnter={e => {
            e.currentTarget.style.background = "#e0f2fe";
            e.currentTarget.style.borderColor = "#7dc4d8";
          }}
          onMouseLeave={e => {
            e.currentTarget.style.background = "transparent";
            e.currentTarget.style.borderColor = ACCENT;
          }}
        >
          <i className="fas fa-times" aria-hidden="true" />
          Clear Filters
        </button>
      </div>

      {/* Filter controls grid */}
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))",
          gap: 12,
          alignItems: "start",
        }}
      >
        {/* Financial Year */}
        <div>
          <label
            style={{
              display: "block",
              marginBottom: 5,
              fontWeight: 600,
              color: "#64748b",
              fontSize: 11,
              textTransform: "uppercase",
              letterSpacing: "0.05em",
            }}
          >
            Financial Year
          </label>
          <MultiSelectDropdown
            options={financialYearOptions}
            selected={selectedFinancialYears}
            onChange={setSelectedFinancialYears}
            placeholder="Select Financial Years"
            searchPlaceholder="Search financial years..."
          />
        </div>


        {/* Primary Location */}
        <div>
          <label
            style={{
              display: "block",
              marginBottom: 5,
              fontWeight: 600,
              color: "#64748b",
              fontSize: 11,
              textTransform: "uppercase",
              letterSpacing: "0.05em",
            }}
          >
            Primary Location
          </label>
          <select
            value={selectedPrimaryLocation || ""}
            onChange={e => setSelectedPrimaryLocation(e.target.value)}
            style={{
              width: "100%",
              padding: "6px 10px",
              borderRadius: 8,
              border: `1.5px solid ${selectedPrimaryLocation ? ACCENT : "#e2e8f0"}`,
              background: selectedPrimaryLocation ? "#f0f7ff" : "#fff",
              fontSize: 13,
              color: selectedPrimaryLocation ? "#1e293b" : "#94a3b8",
              outline: "none",
              cursor: "pointer",
              minHeight: 34,
              transition: "border-color 0.2s",
            }}
            onFocus={e => { e.target.style.borderColor = ACCENT; }}
            onBlur={e => { e.target.style.borderColor = selectedPrimaryLocation ? ACCENT : "#e2e8f0"; }}
          >
            <option value="">Select Primary Location</option>
            {primaryLocationOptions
              .filter(item => item && item.id)
              .map(item => (
                <option key={item.id} value={item.id}>
                  {item.unitCode || `${item?.location?.area || ""}, ${item?.location?.city || ""}`.trim() || `Location ${item.id}`}
                </option>
              ))}
          </select>
        </div>

        {/* Compare Location */}
        <div>
          <label
            style={{
              display: "block",
              marginBottom: 5,
              fontWeight: 600,
              color: "#64748b",
              fontSize: 11,
              textTransform: "uppercase",
              letterSpacing: "0.05em",
            }}
          >
            Compare With Location
          </label>
          <select
            value={selectedCompareLocation || ""}
            onChange={e => setSelectedCompareLocation(e.target.value)}
            style={{
              width: "100%",
              padding: "6px 10px",
              borderRadius: 8,
              border: `1.5px solid ${selectedCompareLocation ? ACCENT : "#e2e8f0"}`,
              background: selectedCompareLocation ? "#f0f7ff" : "#fff",
              fontSize: 13,
              color: selectedCompareLocation ? "#1e293b" : "#94a3b8",
              outline: "none",
              cursor: "pointer",
              minHeight: 34,
              transition: "border-color 0.2s",
            }}
            onFocus={e => { e.target.style.borderColor = ACCENT; }}
            onBlur={e => { e.target.style.borderColor = selectedCompareLocation ? ACCENT : "#e2e8f0"; }}
          >
            <option value="">Select Location to Compare</option>
            {compareLocationOptions
              .filter(item => item && item.id)
              .map(item => (
                <option key={item.id} value={item.id}>
                  {item.unitCode || `${item?.location?.area || ""}, ${item?.location?.city || ""}`.trim() || `Location ${item.id}`}
                </option>
              ))}
          </select>
        </div>
      </div>
    </div>
  );
};

export default FilterSectionForComparativeAnalysis;
